import { useState, type ReactNode } from 'react'
import { Brand } from './Brand'

export function PublicShell({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false)
  return <div className="public-site">
    <a className="skip-link" href="#main">Skip to content</a>
    <div className="showcase-bar"><span>Interactive product showcase</span><a href="/login">About this preview →</a></div>
    <header className="public-header shell">
      <Brand />
      <button className="mobile-nav-button" aria-expanded={open} onClick={() => setOpen(!open)}>Menu</button>
      <nav className={open ? 'public-nav open' : 'public-nav'} aria-label="Main navigation">
        <a href="/how-it-works">How it works</a><a href="/project-types">Project blueprints</a><a href="/resources">Resources</a><a href="/pricing">Pricing</a>
      </nav>
      <div className="header-actions"><a className="button button-dark button-small" href="/app?demo=1">Explore live sample</a></div>
    </header>
    <main id="main">{children}</main>
    <footer className="public-footer">
      <div className="shell footer-grid"><div><Brand /><p>Plan the work. Level the bids. Control the project.</p></div><div><strong>Product</strong><a href="/how-it-works">How it works</a><a href="/project-types">Project types</a><a href="/pricing">Product roadmap</a></div><div><strong>Trust</strong><a href="/security">Security</a><a href="/privacy">Privacy</a><a href="/accessibility">Accessibility</a></div><div><strong>Company</strong><a href="/contact">Contact</a><a href="/terms">Terms</a><a href="/refunds">Purchases</a></div></div>
      <div className="shell footer-bottom"><span>© 2026 The Owner’s Desk · A Cory Cape product concept</span><span>Interactive sample data only. Independent homeowner education—not legal, engineering, code, financial, or contractor-vetting advice.</span></div>
    </footer>
  </div>
}
